export default ({ couponRepository, maps, auth }) => {
	return async (payload) => {
		const { onSuccess, onError, data, actions, dispatch } = payload;

		try {
			const coupon = await couponRepository.addCouponWhattsApp({
				data,
				actions,
				maps,
				dispatch,
				auth: auth(),
			});

			onSuccess({ coupon });
		} catch (e) {
			console.log(e);

			onError();
		}
	};
};
